__turbopack_export_value__({
  "grid": "StructureImages-module-scss-module__sYvTLa__grid",
  "grid__item": "StructureImages-module-scss-module__sYvTLa__grid__item",
  "grid__list": "StructureImages-module-scss-module__sYvTLa__grid__list",
  "grid__main": "StructureImages-module-scss-module__sYvTLa__grid__main",
  "oneImage": "StructureImages-module-scss-module__sYvTLa__oneImage",
});
